export default __webpack_public_path__ + "static/media/dozule18.851b4e89.jpg";